import { ApiResponse, PaginatedCollection, directusApi } from '@/api';
import lodash from 'lodash';
var slugify = require('slugify');

export interface Blog {
    id?: number;
    title?: string;
    content?: string;
    slug?: string;
    status?: boolean;
    featured_image?: Array<any>;
}

export interface BlogState {
    activeBlog: Blog | null;
    activeBlogLoading: boolean;

    allBlogs: Array<Blog>;
    allBlogsLoading: boolean;
    blogsPerPage: number;
    blogsPage: number;
    blogsTotal: number;
}

const defaultBlog = {
    id: 0,
    title: '',
    content: '',
    slug: '',
    status: false,
    featured_image: []
};

const state: BlogState = {
    activeBlog: {
        id: 0,
        title: '',
        content: '',
        slug: '',
        status: false,
        featured_image: []
    },
    activeBlogLoading: false,

    allBlogs: [],
    allBlogsLoading: false,
    blogsPerPage: 1,
    blogsPage: 1,
    blogsTotal: 1,
};

const mutations = {
    toggleallBlogsLoading(state: BlogState, data: boolean) {
        state.allBlogsLoading = data;
    },
    setAllBlogs(state: BlogState, data: PaginatedCollection) {
        state.allBlogs = data.items;
        state.blogsPerPage = data.perPage;
        state.blogsPage = data.currentPage;
        state.blogsTotal = data.totalItems;
    },
    toggleActiveBlogLoading(state: BlogState, data: boolean) {
        state.activeBlogLoading = data;
    },
    setActiveBlog(state: BlogState, data: Blog) {
        state.activeBlog = data;
    },
};

const actions = {
    async putOne({ _, commit }: any, data: any) {},

    async getOne({ _, commit }: any, id: any | null = null) {
        commit('toggleActiveBlogLoading', true);
        if (id != null) {
            await directusApi('GET', `items/blog_posts/${id}`)
            .then(res => {
                commit('setActiveBlog', res.data.data);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('toggleActiveBlogLoading', false);
            });
        } else {
            commit('setActiveBlog', defaultBlog);
            commit('toggleActiveBlogLoading', false);
        }
    },

    async toggleBlogFalse({ _, commit }: any) {
        commit('toggleActiveBlogLoading', false);
    },
    async getAll( { _, commit }: any, {search,page}: any) {
        commit('toggleallBlogsLoading', true);

        let limit = 10;
        let params = '';
        if (search) {
            params += `&filter[title][_contains]=${search}`;
        }

        params += `&sort=-created_at&meta=total_count&meta=filter_count`;
        if (page) params += `&limit=20&offset=${(page - 1) * limit}`;
        let endpoint = `items/blog_posts?${params}`;

        await directusApi('GET', endpoint)
            .then(res => {
                commit('setAllBlogs', {
                    items: res.data.data,
                    perPage: limit,
                    currentPage: page,
                    totalItems: res.data.meta.filter_count,
                });
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('toggleallBlogsLoading', false);
            });
    },
    async postOne({ _, commit, dispatch }: any, { vm, blogData }: any) {
        console.log('data of blog to update ', blogData);
        // return false;
        commit('toggleActiveBlogLoading', true);

        let productEndpoint: string = 'items/blog_posts';
        let productMethod: any = 'POST';

        if (blogData.id != 0) {
            productMethod = 'PATCH';
            productEndpoint = `items/blog_posts/${blogData.id}`;
        }

        // create or update blog without gallery
        await directusApi(productMethod, productEndpoint, {
            title: blogData.title,
            content: blogData.content,
            slug: slugify(`${blogData.title}`, { replacement: '-', remove: /[*+~.¬=|°,?/%&$#()'"!:@]/g }),
            status: blogData.status
        })
            .then(async blogRes => {

                let featured_image = {};
                blogData.featured_image == '' ? featured_image = null : featured_image = blogRes.data.data.featured_image;

                try {
                    if (blogData.featured_image[0].origin == 'upload') {
                        console.log('uploading', blogData.featured_image[0]);
                        await directusApi('POST', `files`, blogData.featured_image[0].file)
                            .then(async (resFile: any) => {
                                featured_image = { id: resFile.data.data.id};
                            })
                            .catch(err => {
                                console.log(err);
                            });
                    }   
                } catch (error) {
                    console.log('error => no contiene una imagen');
                }

                await directusApi('PATCH', `items/blog_posts/${blogRes.data.data.id}`, {featured_image})
                    .then(async (res: any) => {
                        console.log('image added/updated', res.data.data.featured_image);
                        dispatch('getOne', blogRes.data.data.id);
                        alert('Blog Guardado! Obteniendo información...');
                    })
                    .catch(err => {
                        console.log(err);
                    })
                    .finally(() => {
                        commit('toggleActiveBlogLoading', false);
                    });

            })
            .catch(err => {
                console.log(err);
            }).finally(() => {
                commit('toggleActiveBlogLoading', false);
                dispatch("getAll", {page: 1});
            });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
